<template>
    <div id="news" class="mb-4">
        <v-container>
            <v-layout wrap row>
                <v-flex xs12 sm8>
                    <h1 class="display-1 error--text">For sale!</h1>
                        <sale-block :artworks="sales" />
                    <!-- <h1>Latest news</h1>
                    <v-card class="news-card mb-2 bg-cream" v-for="(item, index) in news" :key="index">
                        <v-card-text>
                        <img src="/img/news.png" class="img-fluid pull-left pr-3" alt="News" width="80" >                            
                            <h2 class="blog-title">{{ item.title }}</h2>
                            <p class="date"> {{item.date}} </p>
                            <div v-html="item.text"></div>
                            <p><a :href="item.link" target="_blank">{{ item.link_text }}</a></p>                            
                        </v-card-text>                        
                    </v-card> -->
                </v-flex>
                <v-flex xs12 sm4>
                    <h1 class="mb-15">Greetings:</h1>
                       <div class="socials">
                            <p>Welcome to the site of Maria Danishvar Brown, cosmopolitan fine artist from Russia who lives and works in Bath, UK.</p>  
                            <p>Maria is a figurative artist specialising in portraiture and teaching, A-level coaching and inspiring children.</p>
                        </div>
                    <h1>Maria's vocal website</h1>
                      <div class="vocal-web-pad mb-5">
                        <a href="http://soprano.maria-danishvar.com/" target="_blank">
                            <img class="img-fluid" src="/img/soprano-link.jpg" alt="Link to Soprano Website">
                        </a>                          
                      </div>
                        <!-- <table class="table-exhibitions" cellspacing="1">
                            <tr>
                                <td class="firstCol">Nov 2010</td>
                                <td class="secondCol">Royal West of England Academy</td>
                                    <td class="thirdCol">Mixed Exhibition</td>
                            </tr>
                            <tr>
                                <td class="firstCol">June 2010</td>
                                <td class="secondCol">Bath Society of Artists</td>
                                    <td class="thirdCol">Mixed Exhibition</td>
                            </tr>
                            <tr>
                                <td class="firstCol">Nov 2009</td>
                                <td class="secondCol">Royal West of England Academy</td>
                                    <td class="thirdCol">Mixed Exhibition</td>
                            </tr>
                            <tr>
                                <td class="firstCol">July 2009</td>
                                <td class="secondCol">Bath Society of Artists</td>
                                    <td class="thirdCol">Mixed Exhibition</td>
                            </tr>
                            <tr>
                                <td class="firstCol">July 2008</td>
                                <td class="secondCol">Bath Society of Artists</td>
                                <td class="thirdCol">Mixed Exhibition</td>
                            </tr>
                            <tr>
                                <td class="firstCol">May 2005</td>
                                <td class="secondCol">Royal Bath and West Show</td>
                                <td class="thirdCol">Shepton Mallet</td>
                            </tr>
                            <tr>
                                <td class="firstCol">May 2003</td><td class="secondCol">Royal Society of Portrait Painters</td><td></td>
                            </tr>
                        </table> -->

                    <h1>Links:</h1>    
                        <table class="table-links" cellpadding="0" cellspacing="1">
                            <tr>
                                <td><a href="http://bath-orthodox.org.uk/" target="_blank">
                                    <img src="/img/links/fr-orthodox-parish.png" alt="Tahitran" border="0" width="140px" class="friends-img" />
                                        </a>
                                </td>
                                <td><a href="http://www.goygbcamp.org.uk/" target="_blank">
                                    <img src="/img/links/fr-greek-orthodox.png" alt="Teresa Simas" border="0" width="140px" class="friends-img" />
                                        </a>              
                                </td>
                                </tr> 
                                <tr>
                                    <td><a href="http://katiataylor.com/" target="_blank">
                                        <img src="/img/links/fr-katra-taylor.png" alt="Katra Taylor" border="0" width="140px" class="friends-img" />
                                            </a>
                                    </td>
                                    <td><a href="http://pedrocarneiro.com/" target="_blank">
                                        <img src="/img/links/fr-pedro-carniero.png" alt="Pedro Carniero.png" border="0" width="140px" class="friends-img" />
                                            </a>
                                    </td>
                                </tr>
                                <tr>                
                                <td><a href="http://teresasimas.com/" target="_blank">
                                    <img src="/img/links/fr-teresa-simas.png" alt="Teresa Simas" border="0" width="140px" class="friends-img" />
                                        </a>
                                </td>

                                <td><a href="http://www.technojeeves.com/" target="_blank">
                                    <img src="/img/links/fr-technojeeves.jpg" alt="Teresa Simas" border="0" width="140px" class="friends-img" />
                                        </a>
                                </td>
                                </tr>
                                <tr><td><a href="http://www.francisfaux.co.uk/" target="_blank">
                                        <img src="/img/links/fr-francisfaux.jpg" alt="Teresa Simas" border="0" width="140px" class="friends-img" />
                                            </a>
                                </td>

                                <td><a href="http://guitar-age-academy.in.ua/" target="_blank">
                                    <img src="/img/links/fr-guitarageacademy.jpg" alt="Teresa Simas" border="0" width="140px" class="friends-img" />
                                        </a>
                                </td>
                            </tr>
                        </table>

                    <h1>Follow Maria</h1> 
                        <table class="socials">
                            <tr>
                                <td>
                                    <iframe src="//www.facebook.com/plugins/like.php?href=http%3A%2F%2Fmariadanishvar.com%2F&amp;send=false&amp;layout=button_count&amp;width=450&amp;show_faces=true&amp;action=like&amp;colorscheme=light&amp;font=segoe+ui&amp;height=80" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:130px; height:20px;" allowTransparency="true"></iframe>
                                </td>
                                <td>&nbsp;</td>
                                <td>
                                    <a href="https://www.facebook.com/mariam.d.brown" target="_blank"><div class="faceIcon"></div></a>
                                </td>
                                <td>
                                    <a href="http://vk.com/id2760376" target="_blank"><div class="vkIcon"></div></a>        
                                </td>
                            </tr>
                        </table> 
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import SaleBlock from '@/components/SaleBlock.vue'
    export default {
        name: 'News',
        components: { SaleBlock },
            data: () => ({
                sales: [
                    {
                        name: 'Odette 1',
                        directory: 'dancers',
                        price: 'ASK',
                        fileName: '9',
                        description: 'Watercolour. 36x50cm'
                    },
                    {
                        name: 'Odette 2',
                        directory: 'dancers',
                        price: 'ASK',                        
                        fileName: '10',
                        description: 'Watercolour and pastel, 40x54cm'
                    },
                    {
                        name: 'Giselle',
                        directory: 'dancers',
                        price: 'ASK',                        
                        fileName: '11',
                        description: 'Watercolour and pastel. 30x42cm'
                    },
                    {
                        name: 'Le Corsaire',
                        directory: 'dancers',
                        price: 'ASK',                        
                        fileName: '12',
                        description: 'Wartercolour and pastel. 39x55cm'
                    },
                    {
                        name: 'Spring',
                        directory: 'still-life',
                        price: 'ASK',                        
                        fileName: '12',
                        description: 'Watercolour 30x40 cm. Unframed'
                    },                       
                    {
                        name: 'Thinking of Cèzanne. Sidari in Corfu',
                        directory: 'landscapes',
                        price: 'ASK',                        
                        fileName: '22',
                        description: 'Oil on panel, 22x30cm unframed or 31x39cm framed'
                    }                                                     
                ],
                // news: [                                      
                //     {
                //         title: 'Exhibition of Art!',
                //         date: 'Saturday, July 6, 2019',
                //         text: '<p>Exhibition of Art in Weston and Newbridge 9 - 11th of May 2019</p>',
                //         link: 'http://www.newbridgeartstrail.com/',
                //         link_text: 'Newbridge and Weston Arts Trail, Bath'
                //     }                                                                                                                                                                            
                // ]
            })
    }
</script>

<style>
    #news {
        background-color: #b4b6b0!important;
    }
    #news .table-exhibitions {
        width: 100%;
    }    
    #news .table-exhibitions td {
        padding: 5px 0;
        border-bottom: 1px dotted #232323;
        font-family: Aial, Helvetica, sans-serif;
    }
    #news .firstCol { 
        font-size: 10px;
        font-style: italic;
        width: 18%;
        vertical-align: top;
    }
    #news .secondCol { 
        font-size: 15px;
        font-weight: 500;
        vertical-align: top;
    }
    #news .thirdCol { 
        font-size: 9px;
        vertical-align: top;
    }
    #news .vocal-web-pad {
        background-color: #000;
        text-align: center;
        border-radius: 5px;
    }
    #news .friends-img {
        border: 1px Solid #333333;
    }
    #news .date {
        font-style: italic;
        margin-bottom: 30px;
    }
    #news .news-card {
        margin-right: 20px;
    }
    #news .socials {
        margin-top: 56px;
        border: 1px dotted grey;
        padding: 20px;
        font-size: 13px;
    }
    .faceIcon {
        width: 50px;
        height: 51px;
        background: url('/img/facebook.png') no-repeat;
        background-position: -9px -7px;
    }
    .faceIcon:hover {
        background-position: -9px -60px;
    }
    .vkIcon:hover {
        background-position: -62px -60px;
    }
    .vkIcon {
        width: 50px;
        height: 51px;
        background: url('/img/facebook.png') no-repeat;
        background-position: -62px -7px;
    }
    .links-center {
        text-align: center!important;
    }

    @media (max-width: 600px) {
        #news .news-card {
            margin-right: 0;
        }
    }
</style>


